import React from 'react';
import { cn } from 'utils/classnames';
import { BaseButton } from 'fronton-react';
import { brandShelfProductName } from './styles';

type BrandShelfProductNameProps = {
  href: string;
  textClassName?: string;
} & React.AnchorHTMLAttributes<HTMLButtonElement>;

export const BrandShelfProductName: React.FC<BrandShelfProductNameProps> = ({
  href,
  className,
  children,
  onClick,
  textClassName,
}) => {
  return (
    <BaseButton
      onClick={onClick}
      href={href}
      className={cn(brandShelfProductName, className)}
      data-qa="product-name"
    >
      <span className={textClassName}>{children}</span>
    </BaseButton>
  );
};
